import { Filter } from '@cubejs-client/core';
import { UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import useQuery from '../useQuery';

import { SelectItem } from '@/types/ui';
import { toStringOrNull } from '@/utils/cube';
import { CubeRawRow } from '@/utils/cube/mapper.type';
import { HCP_CUBE_NAME } from '../../hcp';

import { CubeQuery } from '@/types/cube';
import { UserCountriesKeys } from './cacheKeys';

type UseGetUserCountriesRequest = {
  codeFilter?: string[];
};

export function useGetUserCountries<TData = SelectItem[], TError = AxiosError>(
  payload?: UseGetUserCountriesRequest,
): UseQueryResult<TData, TError> {
  const filters: Filter[] = payload?.codeFilter
    ? [{ member: `${HCP_CUBE_NAME}.country_code`, operator: 'equals', values: payload.codeFilter }]
    : [];

  const query: CubeQuery = {
    dimensions: [`${HCP_CUBE_NAME}.country_code`, `${HCP_CUBE_NAME}.country_name`],
    order: { [`${HCP_CUBE_NAME}.country_name`]: 'asc' },
    limit: 1000,
    filters,
  };

  return useQuery<CubeRawRow[], TError, TData>({
    payload: query,
    options: {
      queryKey: [...UserCountriesKeys.list(query)],
      select: data => {
        return data.map(row => ({
          label: toStringOrNull(row[`${HCP_CUBE_NAME}.country_name`], ''),
          value: toStringOrNull(row[`${HCP_CUBE_NAME}.country_code`], ''),
        })) as TData;
      },
      enabled: true,
    },
  });
}
